<template>
  <formio-overview-component
    :formExpansionDefinition=formDefinition
    :buttonLoading=buttonLoading
    @cancel=onCancel
  />
</template>

<script>
import { installFormio } from '../../formio'
export default {
  props: ['formDefinition'],
  data: () => ({
    buttonLoading: false
  }),
  async created() {
    await installFormio()
  },
  methods: {
    changeFormVisible(visible) {
      this.$emit('changeFormVisible', visible)
    },
    onCancel() {
      this.changeFormVisible(false)
    }
  }
}
</script>

<style>
</style>